<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png" />
    <h1>buzme</h1>
    <HelloWorld
      msg="powering existing intercom systems to become part of the smart home ecosystem"
    />
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
  },
};
</script>

<style>
@font-face {
  font-family: "Nordique Pro Semibold";
  src: url("./assets/fonts/NordiquePro-Semibold.otf");
}
h1 {
  font-family: "Nordique Pro Semibold";
  font-size: 2.1rem;
  margin: 10px;
  opacity: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
